<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-23 21:28:29
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/product/detail/components/SpuSkuList/index.vue
-->
<template>
  <div class="spu_list">
    <!-- 左侧spu -->
    <div class="left_spu" @click="switchSpu">
      <img :src="mallretailspu.thumbnailImg" alt="" class="spu_pic" />
    </div>
    <div class="left_line"></div>
    <!--右侧属性  -->
    <div
      v-for="(item, index) in mallretailspu.skuUrl"
      :key="index"
      class="list_item"
      @click="switchSpuSku(index)"
    >
      <div class="item_item">
        <div class="item_sku">
          <img
            :src="item.thumbnailImg"
            alt=""
            :class="{ bor: index === chooseIndex }"
            class="sku_pic"
          />
        </div>
        <div class="sku_name font12 font_weight400 colo055">
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      chooseIndex: -1
    };
  },
  computed: {
    mallretailspu() {
      return this.$store.getters.mallretailspu;
    }
  },
  methods: {
    switchSpuSku(index) {
      this.chooseIndex = index;
      this.$emit("switchSpuSku", index);
    },
    switchSpu() {
      this.$emit("switchSpu");
    }
  }
};
</script>
<style lang="less" scoped>
.spu_list {
  display: flex;
  overflow-y: hidden;
  flex-wrap: nowrap;
  .bor {
    border: 1px solid #000 !important;
  }
  .left_spu {
    padding: 7px 12px 7px;
    .spu_pic {
      width: 36px;
      height: 36px;
      display: block;
      border: 1px solid #000;
      border-radius: 50%;
      box-sizing: border-box;
    }
  }
  .left_line {
    height: 30px;
    margin-top: 11px;
    border-right: 1px solid rgba(0, 0, 0, 0.06);
  }

  .list_item {
    padding: 7px 6px 7px 12px;
    .item_item {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
    }
    .item_sku {
      .sku_pic {
        width: 36px;
        height: 36px;
        display: block;
        border: 1px solid #d9d9d9;
        border-radius: 50%;
      }
    }

    .sku_name {
      white-space: nowrap;
      // line-height: 52px;
      margin-left: 8px;
    }
  }
}
</style>
